export enum PartnerFeatures {
  Chat = "chat",
  PropertyOwner = "property_owner"
}

export enum PropertyManagementSystem {
  Appfolio = "appfolio",
  Buildium = "buildium",
  Entrata = "entrata",
  ManageAmerica = "manage_america",
  Quext = "quext",
  RentManager = "rent_manager",
  RentersWarehouse = "renters_warehouse",
  Rentvine = "rentvine",
  Resman = "resman",
  Yardi = "yardi",
  Propertyware = "propertyware",
  Other = "other"
}

export interface Partner {
  slug: string;
  name: string;
  email: string;
  id: number;
  partner_features?: PartnerFeatures[];
  property_management_system?: PropertyManagementSystem;
}
